import { WisselOpdracht } from '@/queries/mutaties/opdrachten';
import { useMutaties } from '@/queries/mutaties/useMutaties';
import useClientState from '@/state/useClientState';

import { MwdOvergang } from '../types/Domain';
import { geslotenWisselRequest, openWisselRequest } from '../utils/mutationRequests';

import useWerklijnenSubscription_v2 from './useWerklijnSubscription_v2';

const useMutatieWissel = () => {
  const { wissel } = useMutaties();
  const { addWerklijnById } = useWerklijnenSubscription_v2();

  const executeWissel = async (wisselRequest: WisselOpdracht) => {
    const response = await wissel(wisselRequest);
    if (response.status === 'SUCCES' && response.wijzigingen.length) {
      // V2 version: only add the newly created worklineIds
      // First tryout the v2 version of subId.
      const currentIds = new Set(useClientState.getState().werklijnenMap.keys());
      response.wijzigingen
        .filter((wijziging) => wijziging.status === 'NIEUW_OF_GEWIJZIGD' && !currentIds.has(wijziging.id))
        .forEach((wijziging) => addWerklijnById(wijziging.id));
    }
  };

  /**
   * Open wissel (wissel naar Manco).
   */
  const openWissel = async () => {
    const overgang = useClientState.getState().selected.overgangen?.[0];
    if (!overgang) {
      console.warn('Geen geselecteerde overgang gevonden, kan niet open wisselen.');
      return;
    }
    await executeWissel(openWisselRequest(overgang) as unknown as WisselOpdracht);
  };

  /**
   * Een gesloten wissel wordt altijd op basis van 2 geselecteerde overgangen uitgevoerd.
   */
  const geslotenWissel = async () => {
    const selectedOvergangen = useClientState.getState().selected.overgangen;
    if (selectedOvergangen.length !== 2) {
      console.warn('Gesloten wisselen kan alleen wanneer 2 overgangen geselecteerd zijn.');
      return;
    }
    // Argument for not using the above executeWissel is because it already exists.
    // TO-DO find out if it also works with executeWissel for consistency.
    await wissel(geslotenWisselRequest(selectedOvergangen as [MwdOvergang, MwdOvergang]) as unknown as WisselOpdracht);
  };

  return {
    openWissel,
    geslotenWissel,
  };
};
export default useMutatieWissel;
